import { render, staticRenderFns } from "./PopularBrands.vue?vue&type=template&id=c03e282a&"
import script from "./PopularBrands.vue?vue&type=script&lang=js&"
export * from "./PopularBrands.vue?vue&type=script&lang=js&"
import style0 from "./PopularBrands.vue?vue&type=style&index=0&id=c03e282a&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports